import { Modal } from "antd";
import BankDetailsList from "./BankDetailsList";
import type { DropdownOption } from "@/common/components/DynamicSelect";
import { useTranslation } from 'react-i18next';


interface BankDetailsModalProps {
    visible: boolean;
    onClose: () => void;
    policyHolder: DropdownOption;
    onSuccess: () => void;
    cardNumber?: string;
}

const BankDetailsModal = ({ visible, onClose, policyHolder, onSuccess, cardNumber }: BankDetailsModalProps) => {
    const { t } = useTranslation();
    return (
        <Modal
            title={t("Bank Details")}
            visible={visible}
            onCancel={onClose}
            closable={true}
            footer={null}
            width={800}
        >
            <BankDetailsList policyHolder={policyHolder} onSuccess={onSuccess} cardNumber={cardNumber} modalVisible={visible} onModalClose={onClose} />
        </Modal>
    );
};

export default BankDetailsModal;